export default __webpack_public_path__ + "static/media/logo.133f50e7.svg";